<template>
  <stormy-dialog
    :show="show"
    title="Domain zum Schutzschild hinzufügen"
    width="lg"
    height="sm"
    @hide="onClose"
  >
    <template #header>
      <div class="p-4 mb-2">
        <stormy-select
          v-model="gid"
          empty
          :placeholder-value="0"
          placeholder="(Alle)"
          label="Google-Account"
          :options="accounts"
          options-name="email"
        />
      </div>
    </template>
    <template #content>
      <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <tbody class="overflow-y">
          <tr
            v-for="domain in sites"
            :key="domain.url"
            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
          >
            <td
              scope="col"
              class="p-4"
            >
              <stormy-radio-button
                v-model="url"
                :value="domain.url"
              />
            </td>
            <td
              scope="row"
              class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap truncate"
            >
              {{ domain.url }}
            </td>
            <td class="px-6 py-4 truncate">
              {{ domain.gmail }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template #footer>
      <div class="flex-1 flex items-center w-full">
        <div class="flex-1 space-x-2">
          <stormy-button
            variant="default"
            @click="onClose"
          >
            Abbrechen
          </stormy-button>
        </div>
        <div class="flex-none space-x-2">
          <stormy-button
            :disabled="!url"
            variant="primary"
            @click="onClick"
          >
            Domain hinzufügen
          </stormy-button>
        </div>
      </div>
    </template>
  </stormy-dialog>
</template>

<script setup>
import { computed, ref, toRefs } from 'vue'
import { useProp } from '@/composables/useProp.js'
import sortOn from 'sort-on'

const accounts = computed(() => domains.value.filter(item => item.domains.length).map(item => item.account))

const gid = ref(0)
const url = ref('')

const props = defineProps({
  show: useProp(Boolean),
  domains: useProp(Array)
})

const { domains, show } = toRefs(props)

const sites = computed(() => {
  if (gid.value > 0) {
    const account = domains.value.find(item => parseInt(item.account.id) === parseInt(gid.value))
    if (account && account.domains.length) {
      return sortOn(account.domains, 'domain')
    }
  } else {
    const allDomains = domains.value.map(item => item.domains)
    return sortOn(allDomains.flat(), 'domain')
  }

  return []
})

const emit = defineEmits(['cancel', 'confirm'])

const onClose = () => {
  emit('cancel')
}

const onClick = () => {
  const domain = sites.value.find(item => item.url === url.value)
  emit('confirm', domain)
}

</script>
